import gql from 'graphql-tag';

import quoteFragments from './quoteFragments';

export default gql`
${quoteFragments}

mutation DeleteQuoteComponent {
  quoteResponse: deleteQuoteComponent(ids: $ids)
    @rest(
      type: "QuoteUpdate"
      pathBuilder: $pathBuilder
      method: "DELETE",
    ) {
      quote {
        balanceDueDate
        cancellationPenalty
        cancellationPenaltyAvailabileFrom
        campsiteBookings {
          id
          campsite {
            id
            name
            address {
              country
              county
              addressLines
              postCode
            }
            siteCode
            type
          }
          pitches {
            ...Pitch
          }
        }
        crossingBookings @type(name: "CrossingBookings") {
        ...CrossingBooking
        }
        deposit
        departureDate
        errorCode
        extras {
          ...Extra
        }
        quoteId
        outfit {
          externalId
          id
          towHeight
          towLength
          towType
          towMake
          towModel
          vehicleHeight
          vehicleLength
          vehicleMake
          vehicleModel
          vehicleReg
          vehicleType
        }
        partyMembers {
          ...PartyMemberFrag
        }
        product
        status
        totalPrice
      }
    }
  }
`;
